import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class EmployeePositionService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/employeeposition').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getClientStaffPositionDDL(): Observable<IClientStaffPositionDdl[]> {
        return this.http.get<IClientStaffPositionDdl[]>(`${this._url}/clientStaffPositionDdl`);
    }

    getEmployeePositionMapping(): Observable<EmployeePositionMapping[]> {
        return this.http.get<EmployeePositionMapping[]>(`${this._url}/mapping`);
    }

    getPositions(): Observable<StaffPosition[]> {
        return this.http.get<StaffPosition[]>(`${this._url}`);
    }

    getHierarchyLevels(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/levels`);
    }

    updateEmployeePositionMapping(mapData: EmployeePositionLookupForm[]): Observable<any> {
        let data = {
            data: mapData,
        };

        return this.http.post<any>(this._url + '/mapping', data);
    }

    getAutomaticJobTitleMapping() {
        return this.http.get<any[]>(`${this._url}/mapping/auto`);
    }
}

export interface EmployeePositionMapping {
    employeePositionLookupKey?: number;
    jobTitle: string;
    positionName: string;
    staffPositionKey?: number;
    jobCode: string;
}

export interface StaffPosition {
    checked?: boolean;
    staffPositionKey: number;
    category: string;
    position: string;
    class: string;
}

export interface IClientStaffPositionDdl {
    clientStaffPositionKey: number;
    clientPosition: string;
}

export interface EmployeePositionLookupForm {
    staffPositionKey: string;
    jobTitle: string;
    jobCode: string;
}
